import { createFileRoute, redirect } from '@tanstack/react-router'
import { redirectLegacyInsightsLink } from '@routes/_auth/insights/-legacyInsightsLink'

// The old Insights dashboard page, `/insights/dashboards?dashboard=<legacy id>`.
// TODO CRPM-4245 27R1: always send to the old-link 404 page instead of looking the id up; see
// "Legacy Insights links" in TODO.md.
export const Route = createFileRoute('/_auth/insights/dashboards')({
  beforeLoad: ({ context: { scopedEnablements }, location }) => {
    if (!scopedEnablements.global().hasStandardEnablement('Analytics', 'READ')) {
      throw redirect({
        to: '/403',
        replace: true,
      })
    }
    return redirectLegacyInsightsLink(location.searchStr, location.hash)
  },
})
